import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Topbar from './Topbar/Topbar';
import Drawer from './Drawer/Drawer';
import { toggleDrawer } from "../redux/actions/drawerActions";
import { Outlet, useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import useDrawerVisible from '../hooks/useDrawerVisible';

const Layout = () => {
    const isDrawerVisible = useDrawerVisible();
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleToggleDrawer = () => {
        dispatch(toggleDrawer());
    };

    const isMobile = useIsMobile();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/login");
        }
    }, [isLoggedIn, navigate]);

    const drawerStyle = isMobile
        ? {
            width: '100%',
            height: 'calc(100vh - 50px)',
            top: '42px',
            position: 'fixed',
            backgroundColor: 'white',
            borderRight: 'none',
            boxSizing: 'border-box',
            zIndex: 1000,
        }
        : {
            width: '240px',
            height: 'calc(100vh - 42px)',
         //   marginTop: '42px',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            borderRight: '2px solid #e0e0e0',
            boxSizing: 'border-box',
            position: 'absolute',
        };

    const mainStyle = {
        flex: 1,
        overflow: 'auto',
        marginLeft: isMobile || !isDrawerVisible ? 0 : '240px',
        transition: 'margin-left 0.3s ease',
    };

    const topbarStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '0px',
        zIndex: 1001,
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', backgroundColor: '#f7f8fa' }}>
            <div style={topbarStyle}>
                <Topbar toggleDrawer={handleToggleDrawer} />
            </div>
            <div style={{ display: 'flex', height: 'calc(100vh - 50px)', marginTop: '42px', overflow: 'hidden' }}>
                {isLoggedIn && isDrawerVisible && (
                    <div style={drawerStyle}>
                        <Drawer />
                    </div>
                )}
                <div style={mainStyle}>
                    <div
                        style={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            padding: '10px',
                            paddingBottom: '25px',
                        }}
                    >
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
